import { render } from "./addSubscriber.vue?vue&type=template&id=bda38308&scoped=true"
import script from "./addSubscriber.vue?vue&type=script&lang=js"
export * from "./addSubscriber.vue?vue&type=script&lang=js"

import "./addSubscriber.vue?vue&type=style&index=0&id=bda38308&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda38308"]])

export default __exports__